import { inject, Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {APIRequestResources, CachedAPIRequest, LoadingService} from "../../../core";
import {Router} from "@angular/router";
import { BehaviorSubject, catchError, finalize, Subject, tap } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { handleError } from 'src/app/core/utils/utils';
import { MachineTypeDTO } from '../interface/machine-type.entity';


@Injectable({
  providedIn: 'root'
})
export class MachineTypeService extends CachedAPIRequest {

      loading = inject(LoadingService);
      private refreshTrigger = new Subject<void>();
  
      $all = new BehaviorSubject<MachineTypeDTO[]>([]);
      all = toSignal(this.$all, {initialValue: []});

  constructor(protected override http: HttpClient, private router: Router) {
    super(http, APIRequestResources.MachineTypeService )
  }


getAll(refresh = true) {
    return this.get<MachineTypeDTO[]>({}, refresh ? 'freshness' : 'performance')
      .pipe(
        tap(res => this.$all.next(res.data)),
        catchError(handleError)
      )
  }

}
